import { useState, VFC } from 'react';
import { Container, Row, Col } from 'react-grid-system';
import styled from 'styled-components';
import Spacing from '../components/atoms/Spacing';
import Typography from '../components/atoms/Typography';
import { useSettings } from '../contexts/settingsContext';
import Banner from '../components/molecules/Banner';
import ShippingForm from '../components/organisms/form/ShippingForm';

interface Props {
  radius?: string;
}

const Border = styled(Container)<Props>`
  border-radius: ${({ radius }) => radius};
  border: 1px solid #e0e0e0;
`;

const Section = styled(Row)`
  border-bottom: 1px solid #e0e0e0;
  padding: 3.2rem 0px;
`;

const ReturnFreightSummaryPage: VFC = () => {
  const [postReturnError, setPostReturnError] = useState<boolean>(false);
  const { cornerRadius } = useSettings();

  return (
    <Border radius={cornerRadius}>
      <Section justify="center">
        <Typography translateKey="shipping_header" variant="h3" />
      </Section>
      {postReturnError && (
        <>
          <Spacing spacing={4} />
          <Banner variant="error" message="registration_failed" />
        </>
      )}
      <Section>
        <Col xs="content">
          <Typography translateKey="shipping_description" />
        </Col>
      </Section>
      <Spacing spacing={4} />
      <ShippingForm setPostReturnError={setPostReturnError} />
    </Border>
  );
};

export default ReturnFreightSummaryPage;
